// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"sy_a bhp_b bhp_bj","SubscribedPhotoblogs__link":"sy_b bhp_a bhp_r"};